/* Base translations · ISQM 1 page — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): isqmPage. */
export const I18N_BASE_ISQM = {
  en: {
    isqmPage: {
      loading: "Loading ISQM…",
      accessDenied: "Access denied. The ISQM (Quality Management) tab is restricted to Partners and Partner-invited individuals.",
      title: "ISQM (Quality Management)",
      subtitle: "SOQM status, firm-level ISQM 1, and engagement-level ISQM 2 (EQ Review).",
      tabDashboard: "Dashboard",
      tabFirm: "ISQM 1 · Firm (15)",
      tabRegisters: "Registers",
      tabEng: "ISQM 2 · {client} (3)",
      dashLoadFailed: "Dashboard load failed",
      dashLoading: "Loading…",
      dashDeficienciesTitle: "Deficiencies (510a)",
      dashOpen: "Open",
      dashPendingEff: "Pending Effectiveness Review",
      dashRemediated: "Remediated",
      dashRemediationsTitle: "Remediations (511a)",
      dashOverdue: "Overdue",
      dashDueSoon: "Due in ≤30 days",
      dashOnTrack: "On track",
      dashCompleted: "Completed",
      dashAnnualTitle: "Annual Evaluation (512a)",
      dashNotConcluded: "— Not yet concluded —",
      dashOpen512a: "Open 512(a) →",
      dashComplaintsTitle: "Complaints (514a)",
      dashUnderInvestigation: "Under investigation",
      regTabDef: "Deficiencies (510a)",
      regTabRem: "Remediations (511a)",
      regTabComp: "Complaints (514a)",
      regTabInsp: "Inspections (509a)",
      statuses: {
        open: "Open",
        pending_effectiveness_review: "Pending Effectiveness Review",
        remediated: "Remediated (Effectiveness Confirmed)",
        planned: "Planned",
        in_progress: "In progress",
        completed: "Completed",
        under_investigation: "Under investigation",
        resolved: "Resolved",
      },
      dashLastSaved: "Last saved {date}",
      dashNoSave: "No save yet",
      defTitle: "Deficiency Register — Form 510(a)",
      defAdd: "+ Add deficiency",
      defColDesc: "Description",
      defColSource: "Source",
      defColSeverity: "Severity",
      defColStatus: "Status",
      defEmpty: "No deficiencies recorded yet.",
      defRootCausePrefix: "Root cause:",
      defConfirmDelete: 'Delete deficiency "{desc}"?',
      actEdit: "Edit",
      actDelete: "Delete",
      toastDeleted: "Deleted",
      toastDeleteFailed: "Delete failed",
      impactCannotDelete: "Cannot delete — deficiency is in use",
      impactRefIntroPre: '"{desc}" is currently referenced by',
      impactRefIntroPost: "row(s) across three registers. Unlink or delete each of them first, then retry the delete.",
      impactRemsLabel: "Remediations (Form 511a) · {n}",
      impactCompsLabel: "Complaints (Form 514a) · {n}",
      impactInspsLabel: "Inspections (Form 509a) · {n}",
      impactOwnerPrefix: "· owner",
      impactInspectorPrefix: "· inspector",
      impactNoDate: "no date",
      gotIt: "Got it",
      defDialogTitleAdd: "Add deficiency",
      defDialogTitleEdit: "Edit deficiency",
      defDialogDesc: "Records to 510(a) register. Live-referenced by remediations (511a) and complaints (514a).",
      defLabelDescription: "Description",
      defLabelSource: "Source",
      defLabelSeverity: "Severity",
      defLabelRootCause: "Root cause",
      defLabelStatus: "Status",
      defSourceInsp: "Monitoring inspection",
      defSourceComp: "Complaint/allegation",
      defSourceOther: "Other",
      defSeverityPlaceholder: "Low / Moderate / High",
      defStatusOpen: "Open",
      defStatusPendEff: "Pending Effectiveness Review",
      defStatusRem: "Remediated (Effectiveness Confirmed)",
      defRemHint: '"Remediated" is a Partner judgment call — never auto-set by AZEX (per ISQM 1 — monitoring and remediation).',
      cancel: "Cancel",
      save: "Save",
      add: "Add",
      toastDescRequired: "Description required",
      toastSaved: "Saved — logged to Audit Trail",
      toastSaveFailed: "Save failed",
      remTitle: "Remediation Plan — Form 511(a)",
      remAdd: "+ Add remediation",
      remAddDefFirst: "Add a deficiency first — remediations must link to one.",
      remColDef: "Deficiency (510a)",
      remColAction: "Action",
      remColOwner: "Owner",
      remColDate: "Target date",
      remColStatus: "Status",
      remColEff: "Eff.",
      remEmpty: "No remediations recorded.",
      remDeleted: "(deleted)",
      remConfirmed: "Confirmed ✓",
      remConfirmDelete: "Delete remediation?",
      toastPickDefLink: "Pick a deficiency (510a) to link",
      toastActionRequired: "Action required",
      remDialogTitleAdd: "Add remediation",
      remDialogTitleEdit: "Edit remediation",
      remDialogDesc: "Links live to a 510(a) deficiency. Editing the deficiency updates every remediation row that points to it.",
      remLabelDef: "Deficiency (Form 510a) *",
      remDefPlaceholder: "— pick a deficiency —",
      remLabelAction: "Remediation action",
      remLabelOwner: "Owner",
      remLabelDate: "Target date",
      remLabelStatus: "Status",
      remStatusPlanned: "Planned",
      remStatusInProgress: "In progress",
      remStatusCompleted: "Completed",
      remEffConfirmed: "Effectiveness confirmed (ISQM 1 — subsequent monitoring cycle demonstrated the fix worked)",
      remEffEvidence: "Evidence reference (e.g. 509a inspection ID / date)",
      remCompletedNote: 'Setting Status to "Completed" auto-flips the linked deficiency to "Pending Effectiveness Review". It does NOT auto-flip it to "Remediated" — that requires an explicit Partner status change on the deficiency itself.',
      compTitle: "Complaints & Allegations — Form 514(a)",
      compAdd: "+ Add complaint",
      compColDate: "Date",
      compColNature: "Nature",
      compColSource: "Source",
      compColLinked: "Linked deficiency (510a)",
      compColStatus: "Status",
      compEmpty: "No complaints recorded.",
      compDeleted: "(deleted)",
      compConfirmDelete: "Delete complaint?",
      compDialogTitleAdd: "Add complaint / allegation",
      compDialogTitleEdit: "Edit complaint",
      compDialogDesc: "Records to 514(a) register. If a real deficiency, link to a 510(a) row (not a copy — a live reference).",
      compLabelDate: "Date received",
      compLabelSource: "Source",
      compLabelNature: "Nature",
      compLabelInvBy: "Investigated by",
      compLabelStatus: "Status",
      compStatusOpen: "Open",
      compStatusUnder: "Under investigation",
      compStatusResolved: "Resolved",
      compLabelOutcome: "Outcome",
      compLabelLinked: "Linked to Form 510(a) deficiency?",
      compNoLink: "— No link —",
      compLinkedHint: "If linked, this is a live reference — editing the deficiency later updates this row automatically.",
      compSourcePlaceholder: "internal / external",
      toastDateRequired: "Date required",
      toastNatureRequired: "Nature required",
      toastUnlinked: "Unlinked",
      inspTitle: "Inspection Log — Form 509(a)",
      inspAdd: "+ Add inspection",
      inspColEng: "Engagement inspected",
      inspColPartner: "Partner",
      inspColDate: "Date",
      inspColFindings: "Findings",
      inspColEsc: "Escalation",
      inspEmpty: "No inspections logged.",
      inspLinkDef: "→ Deficiency",
      inspEscalate: "Escalate",
      inspUnlink: "Unlink",
      inspConfirmDelete: "Delete inspection?",
      inspConfirmUnlink: "Unlink the deficiency reference from this inspection? (The 510a row itself is not deleted.)",
      toastUnlinkFailed: "Unlink failed",
      toastEngInspRequired: "Engagement inspected required",
      inspDialogTitleAdd: "Add inspection",
      inspDialogTitleEdit: "Edit inspection",
      inspLabelEng: "Engagement inspected",
      inspLabelPartner: "Partner",
      inspLabelInspector: "Inspector",
      inspLabelDate: "Date",
      inspLabelFindings: "Findings summary",
      escTitle: "Escalate to Deficiency",
      escDesc: "The inspection stays here. A live reference to a 510(a) deficiency is attached to this row — click the badge later to jump straight to the deficiency.",
      escModeCreate: "Create new deficiency",
      escModeLink: "Link to existing",
      escInspRefLabel: "Inspection ref:",
      escSourceLabel: "Source:",
      escSourceValue: "Monitoring inspection (auto-set on 510a)",
      escNoCarryPre: "Severity + Root cause are left",
      escNoCarryBold: "blank",
      escNoCarryPost: "— those need deliberate evaluation, not carryover.",
      escLabelDesc: "Deficiency description (refine as needed for the register)",
      escLabelPick: "Deficiency to link",
      escPickerPlaceholder: "— pick an open / pending-review deficiency —",
      escConfirm: "Confirm escalation",
      toastPickDef: "Pick a deficiency",
      toastEscLogged: "Escalation logged — deficiency linked",
      toastEscFailed: "Escalate failed",
      firmLoading: "Loading firm-level forms…",
      firmTitle: "ISQM 1 — Firm-Level Quality Management Forms",
      firmExportAll: "Export all (PDF · SHA-256)",
      firmColRef: "Ref",
      firmColForm: "Form",
      firmColStandard: "Standard",
      firmColCompletion: "Completion",
      firmOpen: "Open →",
      firmPdf: "PDF",
      toastExportedSha: "Exported · SHA-256 {sha}…",
      toastExportFailed: "Export failed",
      engLoading: "Loading engagement forms…",
      engTitle: "ISQM 2 — Engagement Quality Review Forms",
      manageAccess: "Manage access",
      verifyBundleBtn: "Verify Bundle",
      verifyTitle: "Verify ISQM export bundle",
      verifyDesc: "Upload a PDF previously exported from any ISQM tab (firm-level, engagement-level, single form or bundle). AZEX recomputes the SHA-256 of the file and compares it against the hash recorded at export time. Access is limited to those who could see the original form.",
      verifyChoose: "Choose an ISQM export .pdf",
      verifyRun: "Verify integrity",
      verifyRunning: "Verifying…",
      verifyReset: "Reset",
      verifyPass: "✓ Verified — matches original export, unaltered",
      verifyFail: "✗ Does not match — file has been modified since export",
      verifyUnknown: "No matching ISQM export on record",
      verifyBundleType: "Bundle type",
      verifyExported: "Exported",
      verifyBy: "By",
      verifyEngagement: "Engagement",
      verifyEngagementFy: "FY",
      verifyScope: "Scope",
      verifyScopeFirmWide: "Firm-wide",
      verifyRecomputed: "Recomputed:",
      verifyOnRecord: "On record:",
      verifySnapshotHash: "Snapshot hash:",
      close: "Close",
      toastVerifyPass: "Bundle verified — unaltered",
      toastVerifyFail: "File has been modified since export",
      toastVerifyUnknown: "No matching export on record",
      toastVerifyFailed: "Verification failed",
      toastVerifyPickPdf: "Please upload the ISQM export .pdf",
      accessTitle: "Manage ISQM access",
      accessDescPre: "Invite specific individuals to view/edit the ISQM tab. Inviting a Preparer or Reviewer does",
      accessDescNotBold: "not",
      accessDescPost: "change their underlying role — it only grants access to this tab. Only Partners can invite or revoke.",
      accessLabelScope: "Scope",
      accessScopeFirm: "Firm — ISQM 1",
      accessScopeEng: "Engagement — ISQM 2",
      accessLabelEng: "Engagement",
      accessPickPlaceholder: "— pick —",
      accessNoEqc: "No EQ-review-flagged engagements in this firm yet.",
      accessLabelUser: "User",
      accessGrant: "Grant",
      accessOrphanBody: "were granted by a Partner who no longer holds the Partner role. Review below and revoke any that no longer represent an intentional access decision.",
      accessActiveLabel: "Active",
      accessActiveGrants: "Active grants ({count})",
      accessColUser: "User",
      accessColRole: "Role",
      accessColScope: "Scope",
      accessColGranted: "Granted by / when",
      accessColActions: "Actions",
      accessNoGrants: "No individual grants yet.",
      accessScopeBadgeFirm: "ISQM 1 (Firm)",
      accessScopeBadgeEngPrefix: "ISQM 2 · Eng",
      accessOrphanNote: "granting Partner removed",
      accessRevoke: "Revoke",
      accessRevokedHistory: "Revoked history (last {count})",
      accessRevokedFirm: "Firm ISQM 1",
      accessRevokedEngPrefix: "Eng",
      accessRevokedBy: "revoked by {name} · {date}",
      accessConfirmRevoke: "Revoke this ISQM access?",
      toastPickUser: "Pick a user",
      toastPickEng: "Pick an engagement",
      toastAccessAlready: "This user already has that access",
      toastAccessGranted: "Access granted — logged to Audit Trail",
      toastGrantFailed: "Failed to grant access",
      toastRevoked: "Revoked — logged to Audit Trail",
      toastRevokeFailed: "Failed to revoke",
      toastLoadAccessFailed: "Failed to load access data",
      eqcHintPre: "The engagement",
      eqcHintPost: 'is not flagged "Requires EQ review", so no ISQM 2 section is available for it.',
      formLoading: "Loading…",
      formBack: "← Back to ISQM",
      formContentPendingPre: "Content for this form will be ingested when",
      formContentPendingPost: "is attached.",
      formSave: "Save form",
      formSaving: "Saving…",
      formFreetextPlaceholder: "Notes / workings",
      formLoadFailed: "Failed to load form",
      chkColItem: "Item",
      chkColResponse: "Response",
      chkColRef: "Standard ref.",
      chkResponseNa: "N/A",
      regRemoveRow: "Remove row",
      regAddRow: "+ Add row",
      remCompletedNoteToast: "",
    },
  },
  ar: {
    isqmPage: {
      loading: "جاري تحميل ISQM…",
      accessDenied: "الوصول مرفوض. تبويب ISQM (إدارة الجودة) مقصور على الشركاء والأفراد المدعوين من قِبَل الشريك.",
      title: "ISQM (إدارة الجودة)",
      subtitle: "حالة SOQM، ISQM 1 على مستوى الشركة، وISQM 2 على مستوى المهمة (مراجعة الجودة).",
      tabDashboard: "لوحة التحكم",
      tabFirm: "ISQM 1 · الشركة (15)",
      tabRegisters: "السجلات",
      tabEng: "ISQM 2 · {client} (3)",
      dashLoadFailed: "فشل تحميل لوحة التحكم",
      dashLoading: "جاري التحميل…",
      dashDeficienciesTitle: "أوجه القصور (510a)",
      dashOpen: "مفتوحة",
      dashPendingEff: "بانتظار مراجعة الفعالية",
      dashRemediated: "تمّت المعالجة",
      dashRemediationsTitle: "المعالجات (511a)",
      dashOverdue: "متأخرة",
      dashDueSoon: "مستحقة خلال ≤30 يومًا",
      dashOnTrack: "على المسار",
      dashCompleted: "مكتملة",
      dashAnnualTitle: "التقييم السنوي (512a)",
      dashNotConcluded: "— لم يتم الاستنتاج بعد —",
      dashOpen512a: "افتح 512(a) →",
      dashComplaintsTitle: "الشكاوى (514a)",
      dashUnderInvestigation: "قيد التحقيق",
      regTabDef: "أوجه القصور (510a)",
      regTabRem: "المعالجات (511a)",
      regTabComp: "الشكاوى (514a)",
      regTabInsp: "التفتيشات (509a)",
      statuses: {
        open: "مفتوحة",
        pending_effectiveness_review: "بانتظار مراجعة الفعالية",
        remediated: "تمّت المعالجة (تم تأكيد الفعالية)",
        planned: "مخططة",
        in_progress: "قيد التنفيذ",
        completed: "مكتملة",
        under_investigation: "قيد التحقيق",
        resolved: "تم الحل",
      },
      dashLastSaved: "آخر حفظ {date}",
      dashNoSave: "لم يتم الحفظ بعد",
      defTitle: "سجل أوجه القصور — النموذج 510(a)",
      defAdd: "+ إضافة قصور",
      defColDesc: "الوصف",
      defColSource: "المصدر",
      defColSeverity: "الشدة",
      defColStatus: "الحالة",
      defEmpty: "لم يتم تسجيل أي قصور بعد.",
      defRootCausePrefix: "السبب الجذري:",
      defConfirmDelete: 'حذف القصور "{desc}"؟',
      actEdit: "تعديل",
      actDelete: "حذف",
      toastDeleted: "تم الحذف",
      toastDeleteFailed: "فشل الحذف",
      impactCannotDelete: "لا يمكن الحذف — القصور مستخدم",
      impactRefIntroPre: '"{desc}" مُشار إليه حاليًا في',
      impactRefIntroPost: "صف/صفوف عبر ثلاثة سجلات. أزل الروابط أو احذفها أولًا، ثم أعد المحاولة.",
      impactRemsLabel: "المعالجات (النموذج 511a) · {n}",
      impactCompsLabel: "الشكاوى (النموذج 514a) · {n}",
      impactInspsLabel: "التفتيشات (النموذج 509a) · {n}",
      impactOwnerPrefix: "· المسؤول",
      impactInspectorPrefix: "· المفتش",
      impactNoDate: "بدون تاريخ",
      gotIt: "فهمت",
      defDialogTitleAdd: "إضافة قصور",
      defDialogTitleEdit: "تعديل القصور",
      defDialogDesc: "يُسجَّل في سجل 510(a). مُشار إليه مباشرة من المعالجات (511a) والشكاوى (514a).",
      defLabelDescription: "الوصف",
      defLabelSource: "المصدر",
      defLabelSeverity: "الشدة",
      defLabelRootCause: "السبب الجذري",
      defLabelStatus: "الحالة",
      defSourceInsp: "تفتيش الرقابة",
      defSourceComp: "شكوى/ادعاء",
      defSourceOther: "أخرى",
      defSeverityPlaceholder: "منخفضة / متوسطة / عالية",
      defStatusOpen: "مفتوحة",
      defStatusPendEff: "بانتظار مراجعة الفعالية",
      defStatusRem: "تمّت المعالجة (تم تأكيد الفعالية)",
      defRemHint: '"تمّت المعالجة" هي قرار تقديري للشريك — لا يتم ضبطه تلقائيًا بواسطة AZEX (وفقًا لـ ISQM 1 — المراقبة والمعالجة).',
      cancel: "إلغاء",
      save: "حفظ",
      add: "إضافة",
      toastDescRequired: "الوصف مطلوب",
      toastSaved: "تم الحفظ — مسجَّل في مسار التدقيق",
      toastSaveFailed: "فشل الحفظ",
      remTitle: "خطة المعالجة — النموذج 511(a)",
      remAdd: "+ إضافة معالجة",
      remAddDefFirst: "أضف قصورًا أولًا — يجب ربط المعالجات بأحد أوجه القصور.",
      remColDef: "القصور (510a)",
      remColAction: "الإجراء",
      remColOwner: "المسؤول",
      remColDate: "التاريخ المستهدف",
      remColStatus: "الحالة",
      remColEff: "الفعالية",
      remEmpty: "لم يتم تسجيل معالجات.",
      remDeleted: "(محذوف)",
      remConfirmed: "مؤكد ✓",
      remConfirmDelete: "حذف المعالجة؟",
      toastPickDefLink: "اختر قصورًا (510a) للربط",
      toastActionRequired: "الإجراء مطلوب",
      remDialogTitleAdd: "إضافة معالجة",
      remDialogTitleEdit: "تعديل المعالجة",
      remDialogDesc: "يرتبط مباشرة بقصور 510(a). تعديل القصور يُحدِّث كل معالجة تشير إليه.",
      remLabelDef: "القصور (النموذج 510a) *",
      remDefPlaceholder: "— اختر قصورًا —",
      remLabelAction: "إجراء المعالجة",
      remLabelOwner: "المسؤول",
      remLabelDate: "التاريخ المستهدف",
      remLabelStatus: "الحالة",
      remStatusPlanned: "مخططة",
      remStatusInProgress: "قيد التنفيذ",
      remStatusCompleted: "مكتملة",
      remEffConfirmed: "تم تأكيد الفعالية (ISQM 1 — أثبتت دورة رقابة لاحقة أن المعالجة نجحت)",
      remEffEvidence: "مرجع الدليل (مثلاً معرف/تاريخ تفتيش 509a)",
      remCompletedNote: 'ضبط الحالة إلى "مكتملة" يُحوِّل القصور المرتبط تلقائيًا إلى "بانتظار مراجعة الفعالية". ولا يحوّله تلقائيًا إلى "تمّت المعالجة" — يتطلب ذلك تغيير حالة صريح من الشريك على القصور نفسه.',
      compTitle: "الشكاوى والادعاءات — النموذج 514(a)",
      compAdd: "+ إضافة شكوى",
      compColDate: "التاريخ",
      compColNature: "الطبيعة",
      compColSource: "المصدر",
      compColLinked: "القصور المرتبط (510a)",
      compColStatus: "الحالة",
      compEmpty: "لم يتم تسجيل شكاوى.",
      compDeleted: "(محذوف)",
      compConfirmDelete: "حذف الشكوى؟",
      compDialogTitleAdd: "إضافة شكوى / ادعاء",
      compDialogTitleEdit: "تعديل الشكوى",
      compDialogDesc: "يُسجَّل في سجل 514(a). إذا كان قصورًا حقيقيًا، فاربطه بصف 510(a) (وليس نسخة — مرجع مباشر).",
      compLabelDate: "تاريخ الاستلام",
      compLabelSource: "المصدر",
      compLabelNature: "الطبيعة",
      compLabelInvBy: "بواسطة المحقِّق",
      compLabelStatus: "الحالة",
      compStatusOpen: "مفتوحة",
      compStatusUnder: "قيد التحقيق",
      compStatusResolved: "تم الحل",
      compLabelOutcome: "النتيجة",
      compLabelLinked: "مربوطة بقصور نموذج 510(a)؟",
      compNoLink: "— بدون ربط —",
      compLinkedHint: "إذا رُبطت، فهذا مرجع مباشر — تعديل القصور لاحقًا يُحدِّث هذا الصف تلقائيًا.",
      compSourcePlaceholder: "داخلي / خارجي",
      toastDateRequired: "التاريخ مطلوب",
      toastNatureRequired: "الطبيعة مطلوبة",
      toastUnlinked: "تم فك الربط",
      inspTitle: "سجل التفتيش — النموذج 509(a)",
      inspAdd: "+ إضافة تفتيش",
      inspColEng: "المهمة المفتَّشة",
      inspColPartner: "الشريك",
      inspColDate: "التاريخ",
      inspColFindings: "النتائج",
      inspColEsc: "التصعيد",
      inspEmpty: "لم يتم تسجيل تفتيشات.",
      inspLinkDef: "← القصور",
      inspEscalate: "تصعيد",
      inspUnlink: "فك الربط",
      inspConfirmDelete: "حذف التفتيش؟",
      inspConfirmUnlink: "فك ربط مرجع القصور من هذا التفتيش؟ (لن يتم حذف صف 510a نفسه.)",
      toastUnlinkFailed: "فشل فك الربط",
      toastEngInspRequired: "المهمة المفتَّشة مطلوبة",
      inspDialogTitleAdd: "إضافة تفتيش",
      inspDialogTitleEdit: "تعديل التفتيش",
      inspLabelEng: "المهمة المفتَّشة",
      inspLabelPartner: "الشريك",
      inspLabelInspector: "المفتش",
      inspLabelDate: "التاريخ",
      inspLabelFindings: "ملخص النتائج",
      escTitle: "تصعيد إلى قصور",
      escDesc: "يبقى التفتيش هنا. يُرفَق مرجع مباشر لقصور 510(a) بهذا الصف — انقر الشارة لاحقًا للانتقال مباشرة إلى القصور.",
      escModeCreate: "إنشاء قصور جديد",
      escModeLink: "ربط بقصور موجود",
      escInspRefLabel: "مرجع التفتيش:",
      escSourceLabel: "المصدر:",
      escSourceValue: "تفتيش الرقابة (يُضبط تلقائيًا على 510a)",
      escNoCarryPre: "الشدة والسبب الجذري يُتركان",
      escNoCarryBold: "فارغين",
      escNoCarryPost: "— يحتاجان إلى تقييم مستقل، لا إلى نقل مباشر.",
      escLabelDesc: "وصف القصور (نقّحه حسب الحاجة للسجل)",
      escLabelPick: "القصور المطلوب ربطه",
      escPickerPlaceholder: "— اختر قصورًا مفتوحًا / بانتظار المراجعة —",
      escConfirm: "تأكيد التصعيد",
      toastPickDef: "اختر قصورًا",
      toastEscLogged: "تم تسجيل التصعيد — تم ربط القصور",
      toastEscFailed: "فشل التصعيد",
      firmLoading: "جاري تحميل نماذج الشركة…",
      firmTitle: "ISQM 1 — نماذج إدارة الجودة على مستوى الشركة",
      firmExportAll: "تصدير الكل (PDF · SHA-256)",
      firmColRef: "المرجع",
      firmColForm: "النموذج",
      firmColStandard: "المعيار",
      firmColCompletion: "الإكمال",
      firmOpen: "فتح ←",
      firmPdf: "PDF",
      toastExportedSha: "تم التصدير · SHA-256 {sha}…",
      toastExportFailed: "فشل التصدير",
      engLoading: "جاري تحميل نماذج المهمة…",
      engTitle: "ISQM 2 — نماذج مراجعة جودة المهمة",
      manageAccess: "إدارة الوصول",
      verifyBundleBtn: "التحقق من الحزمة",
      verifyTitle: "التحقق من حزمة تصدير ISQM",
      verifyDesc: "ارفع ملف PDF سبق تصديره من أي تبويب ISQM (على مستوى الشركة أو المهمة أو نموذج مفرد أو حزمة). يعيد AZEX احتساب SHA-256 للملف ويقارنه بالتجزئة المسجلة عند التصدير. الوصول محدود لمن كان يمكنه رؤية النموذج الأصلي.",
      verifyChoose: "اختر ملف PDF لتصدير ISQM",
      verifyRun: "التحقق من السلامة",
      verifyRunning: "جاري التحقق…",
      verifyReset: "إعادة تعيين",
      verifyPass: "✓ تم التحقق — مطابق للتصدير الأصلي، دون تعديل",
      verifyFail: "✗ غير مطابق — تم تعديل الملف منذ التصدير",
      verifyUnknown: "لا توجد نسخة تصدير ISQM مطابقة في السجل",
      verifyBundleType: "نوع الحزمة",
      verifyExported: "تم التصدير",
      verifyBy: "بواسطة",
      verifyEngagement: "المهمة",
      verifyEngagementFy: "السنة المالية",
      verifyScope: "النطاق",
      verifyScopeFirmWide: "على مستوى الشركة",
      verifyRecomputed: "المُحتسب مجددًا:",
      verifyOnRecord: "المسجَّل:",
      verifySnapshotHash: "تجزئة اللقطة:",
      close: "إغلاق",
      toastVerifyPass: "تم التحقق من الحزمة — دون تعديل",
      toastVerifyFail: "تم تعديل الملف منذ التصدير",
      toastVerifyUnknown: "لا توجد نسخة تصدير مطابقة في السجل",
      toastVerifyFailed: "فشل التحقق",
      toastVerifyPickPdf: "يرجى رفع ملف PDF لتصدير ISQM",
      accessTitle: "إدارة الوصول إلى ISQM",
      accessDescPre: "ادعُ أفرادًا محددين لعرض/تحرير تبويب ISQM. دعوة المُعِد أو المراجع",
      accessDescNotBold: "لا",
      accessDescPost: "تُغيّر دورهم الأساسي — إنما تمنحهم وصولًا لهذا التبويب فقط. الشركاء فقط هم من يستطيعون الدعوة أو الإلغاء.",
      accessLabelScope: "النطاق",
      accessScopeFirm: "الشركة — ISQM 1",
      accessScopeEng: "المهمة — ISQM 2",
      accessLabelEng: "المهمة",
      accessPickPlaceholder: "— اختر —",
      accessNoEqc: "لا توجد مهام موسومة بمراجعة الجودة (EQ) في هذه الشركة بعد.",
      accessLabelUser: "المستخدم",
      accessGrant: "منح",
      accessOrphanBody: "مُنحت بواسطة شريك لم يعد يحمل صلاحية الشريك. راجعها أدناه وألغِ ما لم يعد يمثل قرار وصول متعمَّد.",
      accessActiveLabel: "نشطة",
      accessActiveGrants: "المنح النشطة ({count})",
      accessColUser: "المستخدم",
      accessColRole: "الدور",
      accessColScope: "النطاق",
      accessColGranted: "منحها / متى",
      accessColActions: "الإجراءات",
      accessNoGrants: "لا توجد منح فردية بعد.",
      accessScopeBadgeFirm: "ISQM 1 (الشركة)",
      accessScopeBadgeEngPrefix: "ISQM 2 · مهمة",
      accessOrphanNote: "أُزيل الشريك المانح",
      accessRevoke: "إلغاء",
      accessRevokedHistory: "سجل الإلغاء (آخر {count})",
      accessRevokedFirm: "ISQM 1 للشركة",
      accessRevokedEngPrefix: "مهمة",
      accessRevokedBy: "أُلغيت بواسطة {name} · {date}",
      accessConfirmRevoke: "إلغاء وصول ISQM هذا؟",
      toastPickUser: "اختر مستخدمًا",
      toastPickEng: "اختر مهمة",
      toastAccessAlready: "هذا المستخدم لديه هذا الوصول بالفعل",
      toastAccessGranted: "تم منح الوصول — مسجَّل في مسار التدقيق",
      toastGrantFailed: "فشل منح الوصول",
      toastRevoked: "تم الإلغاء — مسجَّل في مسار التدقيق",
      toastRevokeFailed: "فشل الإلغاء",
      toastLoadAccessFailed: "فشل تحميل بيانات الوصول",
      eqcHintPre: "المهمة",
      eqcHintPost: 'ليست موسومة بـ "تتطلب مراجعة الجودة (EQ)"، لذلك لا يتوفر لها قسم ISQM 2.',
      formLoading: "جاري التحميل…",
      formBack: "← الرجوع إلى ISQM",
      formContentPendingPre: "سيتم إدخال محتوى هذا النموذج عندما يتم إرفاق",
      formContentPendingPost: ".",
      formSave: "حفظ النموذج",
      formSaving: "جاري الحفظ…",
      formFreetextPlaceholder: "ملاحظات / أعمال",
      formLoadFailed: "فشل تحميل النموذج",
      chkColItem: "البند",
      chkColResponse: "الاستجابة",
      chkColRef: "مرجع المعيار",
      chkResponseNa: "غير منطبق",
      regRemoveRow: "إزالة الصف",
      regAddRow: "+ إضافة صف",
      remCompletedNoteToast: "",
    },
  },
};

export default I18N_BASE_ISQM;
